import { Box } from "@mui/material";
import type { CSSProperties } from "react";

type Props = {
  address: string;
  style?: CSSProperties;
};

export const MapEmbed = ({ address, style }: Props) => (
  <Box height={200} width="100%" overflow="hidden" borderRadius={1}>
    <iframe
      width="100%"
      height="100%"
      style={{ border: 0, ...style }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      src={`https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`}
      title={address}
    />
  </Box>
);
